import React from 'react';
import { usePlansAdminService } from 'nekst-api';
import { ConfirmDeletePopup } from 'features/nekst-widgets';
import useSettingsNavigator from '../../../../settings/settingsNavigator';

export default function DeleteGlobalPlanForm(
  props: { state: string, planId: number, setupAreaId: number, setupAreaVersion: string }
) {
  const plansService = usePlansAdminService();

  const settingsNavigator = useSettingsNavigator();

  const deleteFunc = async () => {
    await plansService.deletePlan(props.planId);

    settingsNavigator.openAdminSetupAreaPlansPage(
      props.state,
      props.setupAreaId,
      props.setupAreaVersion
    );
  };

  return (
    <ConfirmDeletePopup
      deleteFunc={deleteFunc}
      message="Are you sure you want to delete this workflow?"
      withConfirmationInput
    />
  );
}
